import React from 'react';

import { handleTTS, audioManager } from '@/src/lib';
import { VolumeIcon } from './SVGIcons';

interface TTSButtonProps {
    text: string;
    onError?: (error: string) => void;
}

export const TTSButton: React.FC<TTSButtonProps> = ({ text, onError }) => {
    const [isPlaying, setIsPlaying] = React.useState(audioManager.isPlaying());

    const handleClick = async () => {
        if (isPlaying) {
            // Stop and do nothing else if THIS instance is playing
            audioManager.stop();
        } else {
            // Another instance is playing; stop and then play this one
            if (audioManager.isPlaying()) {
                audioManager.stop();
                setIsPlaying(false);
            }

            setIsPlaying(true);
            await handleTTS(text, onError, (ip) => setIsPlaying(ip));
        }
    };

    return (
        <span
            onClick={handleClick}
            aria-label="Play text to speech"
            style={{
                cursor: 'pointer',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '6px',
                borderRadius: '50%',
                border: isPlaying ? '1px solid #0077cc' : '1px solid #053E68',
                backgroundColor: isPlaying ? '#e6f3ff' : 'transparent',
                transition: 'all 150ms ease',
            }}
            onMouseEnter={(e) => {
                (e.currentTarget as HTMLElement).style.backgroundColor = isPlaying
                    ? '#d9ecff'
                    : '#f4f9ff';
            }}
            onMouseLeave={(e) => {
                (e.currentTarget as HTMLElement).style.backgroundColor = isPlaying
                    ? '#e6f3ff'
                    : 'transparent';
            }}
        >
            <VolumeIcon color={isPlaying ? '#0077cc' : '#053E68'} />
        </span>
    );
};
